import React from 'react';

const ConfigHoverOverlay = ({ configHover }) => {
  if (!configHover.show || !configHover.data) {
    return null;
  }

  const formatValue = (value) => {
    if (value === null || value === undefined) return 'N/A';
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    return value.toString();
  };

  return (
    <div 
      className="config-hover-overlay"
      style={{
        position: 'fixed',
        left: configHover.position.x + 10,
        top: configHover.position.y - 10,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '4px',
        fontSize: '12px',
        zIndex: 1000,
        pointerEvents: 'none',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        minWidth: '200px'
      }}
    >
      <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
        {configHover.data.fieldName}
      </div>
      <div style={{ marginBottom: '2px' }}>
        <strong>Desired:</strong> {formatValue(configHover.data.desired)}
      </div>
      <div style={{ marginBottom: '2px' }}>
        <strong>Reported:</strong> {formatValue(configHover.data.reported)}
      </div>
      <div style={{ fontSize: '11px', color: configHover.data.synced ? '#4CAF50' : '#FF9800' }}>
        <strong>Status:</strong> {configHover.data.synced ? 'Synced' : 'Out of Sync'}
      </div>
    </div>
  );
};

export default ConfigHoverOverlay;